import {Apollo} from 'apollo-angular';
import { Injectable } from '@angular/core';
import { LoggingService } from '../../framework/logging/logging.service';
import { GlobalEventsService } from './global-events.service';
import { environment } from '../../../environments/environment';
import { ErrorUtilitiesService } from '../components/framework/errorhandling/error-utilities.service';


@Injectable({
    providedIn: 'root'
  })
export class DataGqlServiceLite {

    protected apiServer = environment ? environment.gQLEndpoint : null;

    constructor(
        protected loggingService: LoggingService,
        protected globalEventsService: GlobalEventsService,
        private apollo: Apollo,
        private errorUtilities: ErrorUtilitiesService
    ) { }

    public query<T>(query: any, variables: any) {

        const promise = new Promise<T>((resolve, reject) => {
            new Promise<void>(() => {
                this.globalEventsService.startLoadingData();
                this.apollo
                .query<T>({
                  query: query,
                  variables: variables,
                  fetchPolicy: "network-only",
                })
                .subscribe((response) => {
                  this.globalEventsService.completeLoadingData();
                  resolve(response.data);
                });
            }).catch((response: any) => {
                const error = this.logError({
                    url: query,
                    response: response
                });
                this.globalEventsService.completeLoadingData();
                reject(error);
            });
        });
        return promise;
    }

    private logError(error: { url: string, body?: any, response: any }) {

        this.loggingService.logError(error.response);

        // Use ErrorUtilitiesService to extract user-friendly message
        const userMessage = this.errorUtilities.extractErrorMessage(error.response);

        // Return an error object with the user-friendly message
        return { message: userMessage };
    }
}
